var UrlHelper, m;

m = require('mithril');

UrlHelper = require('../../lib/UrlHelper');

module.exports = {
  controller: function(args) {
    var ctrl, dummyImg, imageSrc, thumbSrc;
    thumbSrc = UrlHelper.getUrl(args.photo.name, 'S');
    imageSrc = UrlHelper.getUrl(args.photo.name, 'L');
    dummyImg = new Image();
    dummyImg.onload = function() {
      m.startComputation();
      ctrl.isLoading(false);
      return m.endComputation();
    };
    dummyImg.src = imageSrc;
    ctrl = this;
    ctrl.isLoading = m.prop(true);
    ctrl.src = function() {
      if (ctrl.isLoading()) {
        return thumbSrc;
      } else {
        return imageSrc;
      }
    };
    return ctrl;
  },
  view: function(ctrl, args) {
    return m('.PhotoDetails', [
      m('img.PhotoDetails__image', {
        src: ctrl.src()
      }), ctrl.isLoading() ? m('.PhotoDetails__loader', [m('.PhotoDetails__message', [m('img[src="imgs/spinner.gif"]')])]) : void 0
    ]);
  }
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL2FwcC9zcmMvdWkvY29tcG9uZW50cy9QaG90b0RldGFpbHMuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL2FwcC9zcmMvdWkvY29tcG9uZW50cy9QaG90b0RldGFpbHMuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUE7O0FBQUEsQ0FBQSxHQUFJLE9BQUEsQ0FBUSxTQUFSOztBQUVKLFNBQUEsR0FBWSxPQUFBLENBQVEscUJBQVI7O0FBRVosTUFBTSxDQUFDLE9BQVAsR0FBaUI7RUFDaEIsVUFBQSxFQUFZLFNBQUMsSUFBRDtBQUVYLFFBQUE7SUFBQSxRQUFBLEdBQVcsU0FBUyxDQUFDLE1BQVYsQ0FBaUIsSUFBSSxDQUFDLEtBQUssQ0FBQyxJQUE1QixFQUFrQyxHQUFsQztJQUNYLFFBQUEsR0FBVyxTQUFTLENBQUMsTUFBVixDQUFpQixJQUFJLENBQUMsS0FBSyxDQUFDLElBQTVCLEVBQWtDLEdBQWxDO0lBR1gsUUFBQSxHQUFXLElBQUksS0FBSixDQUFBO0lBQ1gsUUFBUSxDQUFDLE1BQVQsR0FBa0IsU0FBQTtNQUNqQixDQUFDLENBQUMsZ0JBQUYsQ0FBQTtNQUNBLElBQUksQ0FBQyxTQUFMLENBQWUsS0FBZjthQUNBLENBQUMsQ0FBQyxjQUFGLENBQUE7SUFIaUI7SUFJbEIsUUFBUSxDQUFDLEdBQVQsR0FBZTtJQUVmLElBQUEsR0FBTztJQUNQLElBQUksQ0FBQyxTQUFMLEdBQWlCLENBQUMsQ0FBQyxJQUFGLENBQU8sSUFBUDtJQUNqQixJQUFJLENBQUMsR0FBTCxHQUFXLFNBQUE7TUFBTSxJQUFHLElBQUksQ0FBQyxTQUFMLENBQUEsQ0FBSDtlQUF5QixTQUF6QjtPQUFBLE1BQUE7ZUFBdUMsU0FBdkM7O0lBQU47V0FDWDtFQWhCVyxDQURJO0VBbUJoQixJQUFBLEVBQU0sU0FBQyxJQUFELEVBQU8sSUFBUDtXQUNMLENBQUEsQ0FBRSxlQUFGLEVBQW1CO01BQ2xCLENBQUEsQ0FBRSx5QkFBRixFQUE2QjtRQUFDLEdBQUEsRUFBSyxJQUFJLENBQUMsR0FBTCxDQUFBLENBQU47T0FBN0IsQ0FEa0IsRUFNYixJQUFJLENBQUMsU0FBTCxDQUFBLENBSkwsR0FBQSxDQUFBLENBQUUsdUJBQUYsRUFBMkIsQ0FDMUIsQ0FBQSxDQUFFLHdCQUFGLEVBQTRCLENBQzNCLENBQUEsQ0FBRSw2QkFBRixDQUQyQixDQUE1QixDQUQwQixDQUEzQixDQUFBLEdBQUEsTUFGa0I7S0FBbkI7RUFESyxDQW5CVSJ9
